import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth, setToken } from "../lib/api";
import { toast } from "sonner";
import { GlitchLogo } from "../components/GlitchLogo";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Landing route for the Emergent Google OAuth redirect.
 * URL fragment contains #session_id=<...>. Runs once, exchanges with backend, then routes home.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const data = await auth.googleSession(sessionId);
        if (data.token) setToken(data.token);
        // Clean the hash out of the URL and go to app
        window.history.replaceState({}, document.title, "/");
        toast.success(`Welcome, ${data.user.name}`);
        navigate("/", { replace: true, state: { user: data.user } });
      } catch (e) {
        toast.error("Google sign-in failed");
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center gap-4">
      <GlitchLogo size={72} />
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-blue-300/70">
        Signing you in…
      </div>
    </div>
  );
}
